<template>
	<div v-if="mutantId" id="market-account-edit-root">
		<b-modal
			id="market-account-edit-root"
			ref="modal-market-account-edit"
			v-model="visible"
			size="lg"
			no-close-on-backdrop
			centered
		>
			<div slot="modal-header" class="d-flex align-items-center w-100">
				<h3 class="pl-3 pb-0 mb-0 mr-auto">
					<b>{{ this.mutant.name }}</b> bearbeiten
				</h3>
				<b-button
					class="close ml-0 mr-1 pr-1"
					variant="secondary-outline"
					style="outline: none!important; box-shadow: none!important;"
					@click="close()"
				>×</b-button>
			</div>
			<div slot="modal-footer" class="w-100">
				<b-button variant="primary" class="float-right" @click="save()">Speichern</b-button>
				<b-button variant="secondary" class="float-right mr-2" @click="close()">schliessen</b-button>
			</div>
			<market-account-edit-input-row-component
				v-for="row in inputRows.firstGroup"
				:key="row.propertyName"
				:propertyName="row.propertyName"
				:label="row.label"
				:mutable="row.mutable"
				:marketAccount="mutant"
			></market-account-edit-input-row-component>
			<market-account-edit-input-row-component
				propertyName="lastUpdateTime"
				label="Änderungsdatum"
				:val="formatDate(mutant.lastUpdateTime)"
			></market-account-edit-input-row-component>
			<market-account-edit-input-row-component
				v-for="row in inputRows.secondGroup"
				:key="row.propertyName"
				:propertyName="row.propertyName"
				:label="row.label"
				:mutable="row.mutable"
				:marketAccount="mutant"
			></market-account-edit-input-row-component>
			<market-account-edit-input-row-component
				propertyName="marketId"
				label="Marktplatz"
				:val="mutant.market.name"
				:mutable="false"
			></market-account-edit-input-row-component>
			<market-account-edit-input-row-component
				propertyName="countryId"
				label="Land"
				:val="mutant.country.countryName"
			></market-account-edit-input-row-component>

			<!-- b-row class="my-2" id="market-account-edit-input-row-component-root">
				<b-col class="pr-3">
					<b-row>
						<label class="control-label col-4 d-flex justify-content-center">Marktplatz:</label>
						<div class="col-8 pl-0">
							<b-form-select
								id="edit-modal-market-account-select"
								v-model="mutant.marketId"
								:options="marketOptions"
								size="sm"
								class="d-flex justify-content-end"
							></b-form-select>
						</div>
					</b-row>
				</b-col>
			</b-row>
			<b-row class="my-2" id="market-account-edit-input-row-component-root">
				<b-col class="pr-3">
					<b-row>
						<label class="control-label col-4 d-flex justify-content-center">Marktplatz:</label>
						<div class="col-8 pl-0">
							<b-form-select
								id="edit-modal-market-account-select"
								v-model="mutant.countryId"
								:options="countryOptions"
								size="sm"
								class="d-flex justify-content-end"
							></b-form-select>
						</div>
					</b-row>
				</b-col>
			</b-row -->


			<market-account-edit-input-row-component
				v-for="row in inputRows.thirdGroup"
				:key="row.propertyName"
				:propertyName="row.propertyName"
				:label="row.label"
				:mutable="row.mutable"
				:marketAccount="mutant"
			></market-account-edit-input-row-component>
			<b-row class="my-2" id="market-account-edit-input-row-component-root">
				<b-col class="pr-3">
					<b-row>
						<label class="control-label col-4 d-flex justify-content-center">Prime:</label>
						<div class="col-8 pl-0">
							<b-button
								@click="toggleSwitch('isPrimeAccount')"
								variant="secondary-outline"
								size="sm"
								class="p-0"
								style="outline: none!important; box-shadow: none!important;"
							>
								<span v-if="mutant.isPrimeAccount" style="font-size: 1.5em;">☒</span>
								<span v-else style="font-size: 1.5em;">☐</span>
							</b-button>
						</div>
					</b-row>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>
<script>
export default {
	props: ["mutantId", "marketAccounts"],
	data() {
		return {
			countryOptions: [],
			marketOptions: [],
			visible: false,
			mutant: null,
			inputRows: {
				firstGroup: [
					{ propertyName: "user"                  , label: "User"                 , mutable: true  },
					{ propertyName: "pass"                  , label: "Passwort"             , mutable: true  },
					{ propertyName: "name"                  , label: "Name"                 , mutable: true  },
					{ propertyName: "description"           , label: "Beschriebung"         , mutable: true  },
					{ propertyName: "defaultItemNote"       , label: "Itemnote"             , mutable: true  },
					{ propertyName: "bandwidthListing"      , label: "Anzahl Listing"       , mutable: true  },
					{ propertyName: "bandwidthRepricing"    , label: "Anzahl Repricing"     , mutable: true  },
				],
				// { propertyName: "lastUpdateTime"        , label: "Änderungsdatum"       , mutable: false },
				secondGroup: [
					{ propertyName: "lastUpdateUser"        , label: "Benutzer"             , mutable: false },
					{ propertyName: "lastUpdateReason"      , label: "Grund"                , mutable: false },
				],
				// { propertyName: "marketId"              , label: "Marktplatz"           , mutable: false },
				// { propertyName: "countryId"             , label: "Land"                 , mutable: false },
				thirdGroup: [
					{ propertyName: "shippingFeeCharge"     , label: "Multiaufschlag"       , mutable: true  },
					{ propertyName: "shippingFeeChargeBook" , label: "Multiaufschlag Buch"  , mutable: true  },
					{ propertyName: "ownShippingFee"        , label: "Versandkosten (PIC)"  , mutable: true  },
					{ propertyName: "bvmdFee"               , label: "BVMD Aufschlag"       , mutable: true  },
					{ propertyName: "newAsUsedCategories"   , label: "Fake-Used-Kategorien" , mutable: true  },
					{ propertyName: "createInvoices"        , label: "Rechnungsstellung"    , mutable: false },
					{ propertyName: "bookingAccountNumber"  , label: "Buchungskonto"        , mutable: false },
					{ propertyName: "costCenter"            , label: "Kostenstelle"         , mutable: false },
					{ propertyName: "bookingAccountReduced" , label: "Buchungskonto Buch"   , mutable: false },
					{ propertyName: "minSurcharge"          , label: "Min. Aufschlag"       , mutable: true  },
					{ propertyName: "minSurchargeSsi"       , label: "Min. Afuschlag SSI"   , mutable: true  },
					{ propertyName: "mdsMarketIdentifier"   , label: "MDS ID"               , mutable: false }
				]
				// { propertyName: "isPrimeAccount"        , label: "Prime"                , mutable: true  },
			}
		};
	},
	watch: {
		mutantId: function (newVal) {
			if (newVal !== null) {
				this.visible = true;
				this.mutant = this.marketAccounts.find((x) => x.id === this.mutantId);
				if (!this.mutant) {
					this.$bvToast.toast(
						`MarketAccount mit unbekannter ID: "${this.mutantId}" konnte nicht geoeffnet werden. Bitte den Entwicklern melden.`,
						{
							title: "Market Account Index",
							autoHideDelay: 32000,
							appendToast: false,
							variant: "danger",
						}
					);
				}
			}
		},
	},
	methods: {
		formatDate(dateString) {
			return (dateString) ? moment(dateString).format("DD.MM.YYYY HH:mm") : "-";
		},
		toggleSwitch(propertyName) {
			if(this.mutant[propertyName] === true || this.mutant[propertyName] === 1 || this.mutant[propertyName] === "1" || this.mutant[propertyName] === "true") {
				this.mutant[propertyName] = false;
			}else{
				this.mutant[propertyName] = true;
			}
		},
		isPositiveInteger(str) {
 			return /^\+?(0|[1-9]\d*)$/.test(str);
		},
		isNumeric(str) {
			if (typeof str != "string") return false;
			return !isNaN(str) && !isNaN(parseFloat(str));
		},
		isPositiveNumeric(str) {
			if (typeof str != "string") return false;
			if(isNaN(str))					 return false;
			const maybe = parseFloat(str);
			if(isNaN(maybe)) return false;
			if(maybe > 0)	  return true;
			return false;
		},
		validateMutant() {
			this.mutant.name = this.mutant.name.trim();
			if(!this.mutant.name) {
				this.$bvToast.toast(`Der Marktplatz braucht einen nicht-leeren Namen. Tragen Sie einen Namen in das Feld "Namen" ein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			const duplicateMarketAccount = this.marketAccounts.find( marketAccount => {
				if(marketAccount.id == this.mutant.id) return false; // skip yourself
				return this.mutant.name == marketAccount.name.trim();
			});
			if(duplicateMarketAccount) {
				this.$bvToast.toast(`Ein anderer Market Account mit den Namen "${this.mutant.name}" existiert bereits.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			if( typeof this.mutant.bandwidthListing == "string") {
				this.mutant.bandwidthListing = this.mutant.bandwidthListing.trim();
			}
			if(!this.mutant.bandwidthListing) {
				this.$bvToast.toast(`Anzahl Listing darf nicht leer sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
			}
			if(!this.isPositiveInteger(this.mutant.bandwidthListing)) {
				this.$bvToast.toast(`Anzahl Listing muss eine positive, ganze Zahl sein..`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			if( typeof this.mutant.shippingFeeCharge == "string") {
				this.mutant.shippingFeeCharge = this.mutant.shippingFeeCharge.trim();
			}
			if(!this.mutant.shippingFeeCharge) {
				this.$bvToast.toast(`Multiaufschlag darf nicht leer sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			if(!this.isPositiveNumeric(this.mutant.shippingFeeCharge)) {
				this.$bvToast.toast(`Multiaufschlag muss eine positive Zahl sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			if( typeof this.mutant.shippingFeeChargeBook == "string") {
				this.mutant.shippingFeeChargeBook = this.mutant.shippingFeeChargeBook.trim();
			}
			if(!this.mutant.shippingFeeChargeBook) {
				this.$bvToast.toast(`"Multiaufschlag Buch" darf nicht leer sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			if(!this.isPositiveNumeric(this.mutant.shippingFeeChargeBook)) {
				this.$bvToast.toast(`"Multiaufschlag Buch" muss eine positive Zahl sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}

			if(typeof this.mutant.ownShippingFee == "string") {
				this.mutant.ownShippingFee = this.mutant.ownShippingFee.trim();
			}
			if(!this.mutant.ownShippingFee) {
				this.$bvToast.toast(`"Versandkosten (PIC)" darf nicht leer sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			if(!this.isNumeric(this.mutant.ownShippingFee)) {
				this.$bvToast.toast(`"Versandkosten (PIC)" muss eine Zahl sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}

			if(typeof this.mutant.bvmdFee == "string") {
				this.mutant.bvmdFee = this.mutant.bvmdFee.trim();
			}
			if(!this.mutant.bvmdFee) {
				this.$bvToast.toast(`"BVMD Aufschlag" darf nicht leer sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			if(!this.isNumeric(this.mutant.bvmdFee)) {
				this.$bvToast.toast(`"BVMD Aufschlag" muss eine Zahl sein.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			if(this.mutant.newAsUsedCategories /*<=> nullable*/ && (!/[0-9]+(,[0-9]+)?/.test(this.mutant.newAsUsedCategories))) {
				this.$bvToast.toast(`"Fake-Used-Kategorien" ist falsch formatiert.`,
					{
						title: "Market Account Speichern",
						autoHideDelay: 9000,
						appendToast: false,
						variant: "danger",
					}
				);
				return false;
			}
			this.$bvToast.toast("Felder sind richtig formatiert.",
				{
					title: "Market Account Index",
					autoHideDelay: 2500,
					appendToast: false,
					variant: "success",
				}
			);
			return true;
		},
		close() {
			this.visible = false;
			this.mutant = null;
			this.$emit("closed");
		},
		save() {
			if(!this.validateMutant()) return;
			axios.post("/marketaccount/save", this.mutant)
			.then( response => {
				this.$bvToast.toast("Market-Account gespeichert.",
					{
						title: "Market Account Index",
						autoHideDelay: 3500,
						appendToast: false,
						variant: "success",
					}
				);
				this.close();
			}).catch( error => {
				console.error(error);
				this.$bvToast.toast(`MarketAccount konnte nicht abgespeichert werden.`,
					{
						title: "Market Account Index",
						autoHideDelay: 32000,
						appendToast: false,
						variant: "danger",
					}
				);
			});
		},
		preventDefault(evt) {
			evt.preventDefault();
		}
	},
	created() {
		Promise.all([
			axios.get("/market/all"),
			axios.get("/country/all")
		]).then( ([_markets, _countries]) => {
			this.marketOptions  = _markets  .data.map( x => { return {value: x.id, text: x.name } });
			this.countryOptions = _countries.data.map( x => { return {value: x.id, text: x.countryName } });
		});
	},
};
</script>
